import { render, staticRenderFns } from "./NavProfile.vue?vue&type=template&id=1a901e15&scoped=true&"
import script from "./NavProfile.vue?vue&type=script&lang=js&"
export * from "./NavProfile.vue?vue&type=script&lang=js&"
import style0 from "./NavProfile.vue?vue&type=style&index=0&id=1a901e15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a901e15",
  null
  
)

export default component.exports